<script setup lang="ts">
  import * as changeCase from 'change-case';
  import { computed } from 'vue';

  import type { CreditMemo } from '@stuut/api/models';
  import { CreditMemoStatus } from '@stuut/api/models';
  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  interface InvoiceBadgeProps {
    creditMemo: CreditMemo;
    noLabel?: boolean;
    size?: BadgeVariants['size'];
  }

  const props = defineProps<InvoiceBadgeProps>();

  const label = computed(() => {
    return changeCase.capitalCase(props.creditMemo.status);
  });

  const badgeVariant = (status: CreditMemoStatus) => {
    switch (status) {
      case CreditMemoStatus.OPEN:
        return 'open';
      case CreditMemoStatus.PAID:
        return 'success';
      case CreditMemoStatus.DRAFT:
      case CreditMemoStatus.VOID:
        return 'secondary';
      default:
        return 'outline';
    }
  };
</script>

<template>
  <template v-if="noLabel">
    <Tooltip>
      <TooltipTrigger as-child>
        <Badge class="size-2! p-0 rounded-none" :variant="badgeVariant(props.creditMemo.status)">
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <span class="truncate" :title="label">{{ label }}</span>
      </TooltipContent>
    </Tooltip>
  </template>

  <Badge v-else :size="size || 'sm'" :variant="badgeVariant(props.creditMemo.status)">
    <span class="truncate" :title="label">{{ label }}</span>
  </Badge>
</template>

<style scoped></style>
